import { Layout } from '@Types/map.types';
import mapApi from '@Apis/map.management.api';

export const getLayout = async (): Promise<Layout> => {
	return mapApi.get('/v1/pplayout/0');
};
